(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["spalvinu-inside"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var LAST_KEY = "spalvinu:lod-preview:last";
    var WIDTHS = [320, 480, 640, 800, 960, 1200];

    function getJSON(url) {
      return fetch(url, { credentials: "same-origin" }).then(function (r) {
        if (!r.ok) throw new Error(r.status + " " + url);
        return r.json();
      });
    }

    function pick(list) {
      return list[Math.floor(Math.random() * list.length)];
    }

    // The pairs list gives 800px URLs; the others differ only in width=.
    function srcset(src) {
      return WIDTHS.map(function (width) {
        return src.replace(/([?&])width=\d+/, "$1width=" + width) + " " + width + "w";
      }).join(", ");
    }

    // Lazy, so a visitor who never scrolls down doesn't download it; it
    // stays transparent until its pair is ready too.
    function preview(entry, sizes) {
      var img = document.createElement("img");
      img.className = "spalvinu-category__preview-image is-fresh";
      img.alt = entry[1] || "";
      img.loading = "lazy";
      img.decoding = "async";
      img.sizes = sizes;
      img.srcset = srcset(entry[0]);
      img.src = entry[0];
      return img;
    }

    function loaded(img) {
      return new Promise(function (resolve, reject) {
        if (img.complete && img.naturalWidth) return resolve();
        img.addEventListener("load", function () { resolve(); }, { once: true });
        img.addEventListener("error", reject, { once: true });
      });
    }

    function fallback(slot) {
      var template = slot.querySelector("template[data-lod-fallback]");
      if (template) slot.replaceChildren(template, template.content.cloneNode(true));
    }

    function run(root) {
      var slots = [
        root.querySelector('[data-lod-preview="easy"]'),
        root.querySelector('[data-lod-preview="detailed"]')
      ];
      if (!slots[0] || !slots[1]) return;

      var pages = parseInt(root.getAttribute("data-lod-pages"), 10) || 1;
      var listUrl = root.getAttribute("data-lod-list-url");
      var sizes = root.getAttribute("data-lod-sizes") || "100vw";
      var page = 1 + Math.floor(Math.random() * pages);

      var last = null;
      try { last = localStorage.getItem(LAST_KEY); } catch (err) {}

      getJSON(listUrl + "&page=" + page)
        .then(function (data) {
          var found = (data.pairs || []).length;
          // Pages are picked evenly, so a short page would make its few sets
          // come up far more often than the rest. Keep a short page only in
          // proportion to its size, else try once more; a page past the end
          // (the count is a guess) or without sets falls back to page 1.
          if (found && (found >= 8 || Math.random() < found / 10)) return data;
          var retry = 1 + Math.floor(Math.random() * Math.max(1, pages - 1));
          return getJSON(listUrl + "&page=" + retry).then(function (again) {
            if (again.pairs && again.pairs.length) return again;
            return found ? data : getJSON(listUrl + "&page=1");
          });
        })
        .then(function (data) {
          var pairs = data.pairs || [];
          if (!pairs.length) throw new Error("no sets");
          var pair = pick(pairs);
          var count = Math.min(pair.easy.length, pair.detailed.length);
          if (!count) throw new Error("no images");
          // The same page of both sets shows the same scene; avoid repeating
          // the one shown on the previous visit.
          var index = Math.floor(Math.random() * count);
          var key = pair.handle + "#" + index;
          if (key === last && count > 1) {
            index = (index + 1) % count;
            key = pair.handle + "#" + index;
          }
          var imgs = [preview(pair.easy[index], sizes), preview(pair.detailed[index], sizes)];
          slots[0].append(imgs[0]);
          slots[1].append(imgs[1]);
          try { localStorage.setItem(LAST_KEY, key); } catch (err) {}
          // Both fade in together once both have loaded, so the pair never
          // shows mismatched scenes.
          return Promise.all(imgs.map(loaded)).then(function () {
            imgs.forEach(function (img) { img.classList.remove("is-fresh"); });
          });
        })
        .catch(function () {
          slots.forEach(fallback);
        });
    }

    // Starts at once rather than when the block nears the view: the pairs
    // list is small, and the images themselves still load lazily.
    function init() {
      document.querySelectorAll("[data-lod-random]").forEach(function (root) {
        if (root.dataset.lodRandomBound) return;
        root.dataset.lodRandomBound = "1";
        run(root);
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
    // The theme editor re-renders the section with empty slots.
    document.addEventListener("shopify:section:load", init);
  })();

  } catch(e) { console.error(e); }
})();
})();
